var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drr',{ref:"drr",staticClass:"stage-item-root",style:({
    backgroundImage: _vm.acceItem.imgPath ? ("url(" + (_vm.acceItem.imgPath) + ")") : 'none'
  }),attrs:{"aspectRatio":true,"x":_vm.state.x,"y":_vm.state.y,"w":_vm.state.w,"h":_vm.state.h,"angle":_vm.state.angle,"rotate":true},on:{"resize":_vm.change,"drag":_vm.change,"rotate":_vm.change,"select":_vm.onSelect,"deselect":_vm.onDeselect}})}
var staticRenderFns = []

export { render, staticRenderFns }